import { useEffect } from 'react'
import { ShoesState } from 'src/types'
import { getCtx } from 'src/util/canvas'
import { drawAtomsShoesSideSurface } from '../drawAtomsShoesSideSurface'

export const useDrawShoesSide = (id: string, state: ShoesState) => {
  useEffect(() => {
    const { ctx, canvasWidth } = getCtx(id)
    if (ctx === null) return
    if (state.baseModel.productNumber === '') return
    drawAtomsShoesSideSurface(ctx, state, canvasWidth)
  }, [id, state])
}
